export class LocalizedTextDTO {
  constructor(
    public language: string,
    public text: string,
    public id?: number,
  ) {}
}
